<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">NCR Area Owner CPAR Verification</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">NCR Number</label>
                <input type="text" class="form-control" id="ncr-no" v-model="ncr.ncrNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Reported Date</label>
                <flat-pickr class="form-control" v-model="ncr.ncrDate" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Addressed To</label>
                <input type="text" class="form-control" id="ncr-no" v-model="ncr.memberName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Member To</label>
                <input type="text" class="form-control" id="ncr-no" v-model="ncr.conformanceTypeName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="happened-before">Happened Before</label>
                <input type="checkbox" class="form-control" v-model="ncr.happenedBefore" id="happened-before" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Description</label>
                <textarea class="form-control" id="desc-textarea" v-model="ncr.description" rows="3" disabled></textarea>
            </div>
        </div>
        Root Cause Analysys & Corrective and Preventive Action Internal Data
        <app-datatable :type="'view'" :elements="dtElementsCorrectivePreventiveInternal" :collections="ncr.correctivePreventiveInternal"></app-datatable>
        <br /><br />
        <!-- Corrective External Data
        <app-datatable :type="'view'" :elements="dtElementsExternal" :collections="ncr.correctiveExternal"></app-datatable> -->
        <div class="row">
            <div class="form-group col-6">
              <label for="action">Verify this data?</label>
              <select type = "dropdown" class="form-control" id="action" v-model="ncr.action">
                <option v-for="(list, index) in this.actionLists" :key="index" :value="list.value">{{ list.title }}</option>
              </select>
            </div>
            <div class="form-group col-6">
              <label for="comment">Comment</label>
              <textarea class="form-control" id="comment" v-model="ncr.comment" rows="3"></textarea>
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { ncrUser } from '../../models/ncrUser'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppUploader from '../../components/AppUploader.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import { correctiveExternal, correctivePreventiveInternal } from '../../models/ncrAreaOwner'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable, AppUploader
    },
    data() {
        return {
            ncr: {...ncrUser, correctiveExternal: [], correctivePreventiveInternal: []},
            actionLists: [
                {
                    title: 'Yes',
                    value: 'yes'
                },
                {
                    title: 'No',
                    value: 'no'
                },
          ],
          dtElementsExternal: [
            {
                title: 'Investigation Detail',
                column: 'investigationDetail',
                type: 'text',
                width: 8,
            },
            {
                title: 'Corrective',
                column: 'corrective',
                type: 'text',
                width: 8,
            },
            {
                title: 'Preventive',
                column: 'preventive',
                type: 'text',
                width: 8,
            },
          ],
          dtElementsCorrectivePreventiveInternal: [
              {
                title: 'Action No.',
                column: 'actionNo',
                type: 'text',
                width: 4,
                disable: true
              },
              {
                title: 'Root Cause Type',
                column: 'rootCauseType',
                type: 'dropdown',
                width: 6,
                lists: [
                    {
                        title: 'Machine',
                        value: 'Machine'
                    },
                    {
                        title: 'Man',
                        value: 'Man'
                    },
                    {
                        title: 'Material',
                        value: 'Material'
                    },
                    {
                        title: 'Method',
                        value: 'Method'
                    },
                    {
                        title: 'Environment',
                        value: 'Environment'
                    }
                ]
              },
              {
                title: 'Root Cause Remark',
                column: 'rootCauseRemark',
                type: 'text',
                width: 6,
              },
              {
                title: 'Action Type',
                column: 'actionType',
                type: 'dropdown',
                width: 6,
                lists: [
                    {
                        title: 'Corrective',
                        value: 'Corrective'
                    },
                    {
                        title: 'Preventive',
                        value: 'Preventive'
                    },
                ]
              },
              {
                title: 'Action Remark',
                column: 'actionRemark',
                type: 'text',
                width: 6,
              },
              {
                title: 'Responder Name',
                column: 'picName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'memberCorrective',
                    title: 'Member Data',
                    type: 'table',
                    apiUrl: 'member-management/lookup',
                    filter: ['firstName', 'lastName', 'email'],
                    fields: [
                        {
                            placeholder: 'Responder Name',
                            width: 5,
                            column: 'picName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'First Name',
                            column: 'firstName'
                        },
                        {
                            title: 'Last Name',
                            column: 'lastName'
                        },
                        {
                            title: 'Email',
                            column: 'email'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'picId'
                        },
                        {
                            from: 'firstName',
                            to: 'picName'
                        },
                        {
                            from: 'email',
                            to: 'picEmail'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'PIC Email',
                column: 'picEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Target Date',
                column: 'targetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
          ],
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const ncrApi = api('ncr-area-owner-cpar')
            this.ncr = await ncrApi.getWithParams(this.$route.query.id)
            console.log(this.ncr)
        }
    },
    methods: {
        async save() {
            const ncrApi = api('ncr-area-owner-cpar-verify')
            if(this.$route.query.id !== undefined) {
                await ncrApi.update(this.ncr, this.$route.query.id)
            }
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        cancel() {
            this.$router.push({ name: 'dashboard' })
        },
        finishLookup(data) {
            const currentNcr = this.ncr
            this.ncr = {
                ...currentNcr,
                ...data
            }
        },
        finishUpload(data) {
            const currentNcr = this.ncr
            this.ncr = {
                ...currentNcr,
                ...data
            }
        },
    }
}
</script>